export default __webpack_public_path__ + "bbbe82ffac643bd2a84946a7058682df.png";